import React, { useState, useEffect } from 'react';
import { EventPlanModal } from './EventPlanModal';
import { EventPlanForm, EventPlanFormEventPlan } from './EventPlanForm';
import { useEventPlan } from './useEventPlan';

export const EditEventPlanModal = ({
  isOpen,
  onClose,
  onSubmit,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: ({
    id,
    name,
    startDate,
    startOffset,
    endOffset,
    groupSize,
    location,
  }: EventPlanFormEventPlan) => void;
}) => {
  const { eventPlan } = useEventPlan();
  const [editedEventPlan, setEditedEventPlan] =
    useState<EventPlanFormEventPlan>(eventPlan);

  const handleSubmit = () => {
    if (!editedEventPlan) return;
    const { id, name, startDate, startOffset, endOffset, groupSize, location } =
      editedEventPlan;
    onSubmit({
      id,
      name,
      startDate,
      startOffset,
      endOffset,
      groupSize,
      location,
    });
    onClose();
  };

  useEffect(() => {
    setEditedEventPlan(eventPlan);
  }, [eventPlan]);

  if (!editedEventPlan) return null;

  return (
    <EventPlanModal
      title="Edit Event"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      <EventPlanForm
        eventPlan={editedEventPlan}
        onChange={(updatedEventPlan) => {
          setEditedEventPlan(updatedEventPlan);
        }}
      />
    </EventPlanModal>
  );
};
